module.exports = __webpack_public_path__ + "img/violence.10691bd6.png";